import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Products from './views/Products.vue'
import Database from "@/views/Database";
import Knowledge from './views/Knowledge'
import Case from "@/views/Case";
import About from "@/views/About";
Vue.use(Router)

let originPush = Router.prototype.push
Router.prototype.push = function (location, res, rej) {
  if (res && rej) {
    originPush.call(this, location, res, rej)
  }
  else {
    originPush.call(this, location, () => { }, () => { })
  }
}

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    //  首页
    {
      path: '/',
      name: 'home',
      component: Home
    },
    //  样本库
    {
      path:'/products',
      name:'products',
      component: Products,
      children:[
        {
          path:'/products/qxzn',
          name:'qxzn',
          component:() => import('@/views/products/qxzn.vue'),
        },
        //  样本库
        {
          path:'/products/tissueBank',
          name:'tissueBank',
          component:() => import('@/views/products/TissueBank.vue'),
        },
        {
          path:'/products/transport',
          name:'transport',
          component:() => import('@/views/products/Transport.vue'),
        },
        {
          path:'/products/site',
          name:'site',
          component:() => import('@/views/products/site.vue'),
        },
        {
          path:'/products/download',
          name:'download',
          component:() => import('@/views/products/Download.vue'),
        },
        {
          path:'/products/share',
          name:'share',
          component:() => import('@/views/products/Share.vue'),
        },
        {
          path:'/products/service',
          name:'service',
          component:() => import('@/views/products/Service.vue'),
        },
        {
          path:'/products/iso',
          name:'iso',
          component:() => import('@/views/products/iso.vue'),
        },
        {
          path:'/products/examine',
          name:'examine',
          component:() => import('@/views/products/examine.vue'),
        },
        {
          path:'/products/bioVision',
          name:'bioVision',
          component:() => import('@/views/products/BioVision.vue'),
        },
        //  细胞
        {
          path:'/products/cellNew',
          name:'cellNew',
          component:() => import('@/views/products/cellNew.vue'),
        },
        {
          path:'/products/eCell',
          name:'eCell',
          component:() => import('@/views/products/Ecell.vue'),
        },
        {
          path:'/products/cellVenue',
          name:'cellVenue',
          component:() => import('@/views/products/CellVenue.vue'),
        },
        {
          path:'/products/aabb',
          name:'aabb',
          component:() => import('@/views/products/Aabb.vue'),
        },
        {
          path:'/products/gmp',
          name:'gmp',
          component:() => import('@/views/products/Gmp.vue'),
        },
        //    实验室
        {
          path:'/products/iLab',
          name:'iLab',
          component:() => import('@/views/products/iLab.vue'),
        },
      ]
    },
    //  数据库
    {
      path: '/database',
      name: 'database',
      component: Database,
      children:[
          {
            path:'/database/bioOmics',
            name:'bioOmics',
            component:() => import('@/views/database/BioOmics.vue'),
          },
          {
            path:'/database/sciSmart',
            name:'sciSmart',
            component:() => import('@/views/database/SciSmart.vue'),
          },
          {
          path:'/database/holoData',
          name:'holoData',
          component:() => import('./views/database/holoData.vue')
          }
      ]
    },
    //  知识库
    {
      path: '/knowledge',
      name: 'knowledge',
      component: Knowledge,
      children:[
          {
            path:'/knowledge/special',
            name:'special',
            component:() => import('@/views/knowledge/Special.vue'),
          },
          {
            path:'/knowledge/rare',
            name:'rare',
            component:() => import('@/views/knowledge/Rare.vue'),
          }
      ]
    },
    //  案例
    {
      path:'/case',
      name:'case',
      component: Case,
      children:[
        {
          path:'/case/hospital',
          name:'hospital',
          component:() => import('@/views/case/Hospital.vue'),
        },
        {
          path:'/case/institution',
          name:'institution',
          component:() => import('@/views/case/institution.vue'),
        },
        {
          path:'/case/company',
          name:'company',
          component:() => import('@/views/case/company.vue'),
        }
      ]
    },
    //  关于我们
    {
      path:'/about',
      name:'about',
      component: About,
      children:[
        {
          path:'/about/introduction',
          name:'introduction',
          component:() => import('@/views/about/Introduction.vue'),
        },
        {
          path:'/about/academic',
          name:'academic',
          component:() => import('@/views/about/Academic.vue'),
        },
        {
          path:'/about/news',
          name:'news',
          component:() => import('@/views/about/news.vue'),
        },
        {
          path:'/about/newsItem',
          name:'newsItem',
          component:() => import('@/views/about/newsItem.vue'),
        },
        {
          path:'/about/position',
          name:'position',
          component:() => import('@/views/about/Position.vue'),
        },
        {
          path:'/about/contact',
          name:'contact',
          component:() => import('@/views/about/Contact.vue'),
        }
      ]
    },
  ]
})
